module.exports = "/_next/static/images/vc-475f7d869ee824fb9d1a7a305746e974.svg";